import { useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useStoreActions } from '~/store/store-context';
export const useUpdateNotificationSettingsV2 = function useUpdateNotificationSettingsV2() {
    let { onSuccess } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const { mutate, isLoading, error } = useMutationState({
        mutationFn: (args)=>api.notification.updateNotificationSettingsV2(args),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    QueryKeys.NotificationSettings
                ]
            });
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        }
    });
    return {
        update: mutate,
        isLoading,
        error
    };
};
